import React from 'react'
import styled from 'styled-components'

import Modal from '../Modal'
import Button from '../../components/Button'
import { flexBoxStyles } from '../../components/Flexbox'

const ReportGenerateModal = ({ onClose, isOpen }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closer={true}
    title={<H1>Zlecenie Wygenerowania raportu zostało przyjęte.</H1>}
  >
    <Footer justify="space-between">
      <Button label="Zamknij" marginLeft onClick={onClose} />
      <Button label="Przejdź do raportów" marginLeft link="/app/reports" />
    </Footer>
  </Modal>
)

const H1 = styled.h1`
  font-weight: 400;
  margin-bottom: 1rem;
`
const Footer = styled.div`
  ${flexBoxStyles};
  &::before {
    position: absolute;
    left: 0;
    bottom: 7rem;
    content: '';
    border-bottom: 1px solid #eee;
    width: 100%;
  }
`

export default ReportGenerateModal
